import React, { useState} from 'react';
import { Modal,Button } from 'react-bootstrap';
import ValidationErrors from '../../Common/ValidationErrors';
import {useDispatch, useSelector } from 'react-redux';
import { createAddress,closeModal, updateAddress } from '../../../redux/slices/Customer/AddressesSlice';
import { ThunkDispatch } from '@reduxjs/toolkit';

const  AddressModal = ({formType,selectedAddress={}}) => {
    const [displayModalValidations, setDisplayModalValidations] = useState(false);
    const {formModalErrors,modalShow} = useSelector((state:any) => state.customerAddresses);
    const {states,countries} = useSelector((state:any) => state.settings);
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();

    const [newAddress, setNewAddress] = useState({
        first_name: (formType === 'New' ? '' : selectedAddress['first_name']),
        last_name: (formType === 'New' ? '' : selectedAddress['last_name']),
        address1: (formType === 'New' ? '' : selectedAddress['address1']),
        address2: (formType === 'New' ? '' : selectedAddress['address2']),
        city: (formType === 'New' ? '' : selectedAddress['city']),
        zipcode: (formType === 'New' ? '' : selectedAddress['zipcode']),
        state_id: (formType === 'New' ? '' : selectedAddress['state']['id']),
        country_id: 1,
        mobile: (formType === 'New' ? '' : selectedAddress['mobile']),
        alternate_mobile: (formType === 'New' ? '' : selectedAddress['alternate_mobile']),
        email:'',
        address_id: (formType === 'New' ? '' : selectedAddress['id']) 
    })
     const handleModalClose = () => {
        dispatch(closeModal());
        formType = "New"
    };

    const handleChange = (e) => {
        const { name, value } = e.target; 
        setNewAddress((prevState) => ({
            ...prevState,
            [name]: value
        })); 
    };

    const manageCreateAddress = () => {
        setDisplayModalValidations(true);
        formType === "New" ? dispatch(createAddress(newAddress)) : dispatch(updateAddress(newAddress)); 
        
    };
  
   return (
    <Modal size="xl" show={modalShow} onHide={handleModalClose}>
                
    <Modal.Header closeButton>
        <Modal.Title>{formType} Address</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="mb-3 p-a20">
          { displayModalValidations && <ValidationErrors errors={formModalErrors}/>}
          <div className="col-xl-12">
            {/* <ValidationErrors errors={formErrors}/> */}
            <form className="row">
              <div className="col-md-6">
                <div className="form-group m-b25">
                  <label className="label-title">First Name</label>
                  <input name="first_name" className="form-control"  value={newAddress.first_name}   onChange={handleChange}  placeholder='First Name'/>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group m-b25">
                  <label className="label-title">Last Name</label>
                  <input name="last_name" className="form-control"  value={newAddress.last_name}   onChange={handleChange}  placeholder='Last Name'/>
                </div>
              </div> 
              <div className="col-md-6">
                <div className="form-group m-b25">
                  <label className="label-title">Mobile *</label>
                  <input name="mobile" className="form-control"  value={newAddress.mobile}   onChange={handleChange}  placeholder='Mobile'/>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group m-b25">
                  <label className="label-title">Alternate Mobile *</label>
                  <input name="alternate_mobile" className="form-control"  value={newAddress.alternate_mobile}   onChange={handleChange}  placeholder='Alternate Mobile'/>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group m-b25">
                  <label className="label-title">Street address *</label> 

                  <input name="address1" className="form-control m-b15"  value={newAddress.address1}   onChange={handleChange}  placeholder='House number and street name'/>
                  <input name="address2" className="form-control"  value={newAddress.address2}   onChange={handleChange}  placeholder='Apartment, suite, unit, etc. (optional)'/>

                </div>
              </div>
              <div className="col-md-6">
                <div className="m-b25">
                  <label className="label-title">Town / City *</label>
                  <input name="city" className="form-control"  value={newAddress.city}   onChange={handleChange}  placeholder='City'/>

                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group m-b25">
                  <label className="label-title">ZIP Code *</label>
                  <input name="zipcode" className="form-control"  value={newAddress.zipcode}   onChange={handleChange}  placeholder='Zipcode'/>
                </div>
              </div>
              <div className="col-md-6">
                <div className="m-b25">
                  <label className="label-title">State *</label>
                  <select name="state_id" className=" form-select w-100" onChange={handleChange} value={newAddress.state_id}>
                    <option key={"001"}>Please Select</option>
                    {states.map((state) => <option key={state.id}  value={state.id}>{state.name}</option>)}
                  </select>									
                </div>
              </div>
            
              <div className="col-md-6">
                <div className="m-b25">
                  <label className="label-title">Country / Region *</label>
                  <select name="country_id" className=" form-select w-100" onChange={handleChange} value={newAddress.country_id}>
                    {countries.map((country) => <option key={country.id}  value={country.id}>{country.name}</option>)}
                  </select>	 
                </div>
              </div>
              
              
              
            </form>
          </div>
      </div> 
    </Modal.Body>
    <Modal.Footer>
        <Button variant="primary" onClick={() => manageCreateAddress()}>
            Submit
        </Button>
        <Button variant="secondary" onClick={handleModalClose}>
            Close
        </Button>
    </Modal.Footer> 

      
  </Modal>
  );
}

export default AddressModal;
